
<div class="load-wrapper">
  <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</div>
